import type { ProjectOnboarding, ProjectTask, TaskGroup } from '../types';
import {
  collectGroupMemberTasks,
  type GroupCommentContext,
} from './groupComments';

/** Unique supplier org ids assigned on hub tasks / onboarding rows. */
export function collectSupplierOrgIdsFromTasks(
  tasks: Array<Pick<ProjectTask, 'supplierOrgIds'>>,
): string[] {
  const orgs = new Set<string>();
  for (const t of tasks) {
    for (const id of t.supplierOrgIds ?? []) {
      if (id?.trim()) orgs.add(id.trim());
    }
  }
  return Array.from(orgs).sort();
}

/** Supplier org ids on tasks in a group comment thread (or a single task). */
export function collectTaskAssignedSupplierOrgIdsForComments(input: {
  isGroupMode: boolean;
  groupContext?: GroupCommentContext | null;
  taskId?: string;
  projectTasks: ProjectTask[];
  taskGroups: TaskGroup[];
  projectOnboardings: ProjectOnboarding[];
}): string[] {
  if (input.isGroupMode && input.groupContext) {
    const members = collectGroupMemberTasks(
      input.groupContext,
      input.projectTasks,
      input.taskGroups,
      input.projectOnboardings,
    );
    return collectSupplierOrgIdsFromTasks(members);
  }
  const tid = (input.taskId || '').trim();
  if (!tid) return [];
  const hit = input.projectTasks.find((t) => t.id === tid);
  return hit ? collectSupplierOrgIdsFromTasks([hit]) : [];
}
